<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Employee  
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <!-- <b-button variant="btn btn-primary mr-1" @click="apihrdcallconfirm"> <i class="fa fa-refresh"></i>Synch with HRD</b-button> -->
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="7">
            <b-row>
              <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Report To</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.mangerInfo" placeholder="Manager Name"></b-form-input>
                    </b-input-group>
                </b-col>
            </b-row>            
            <b-row>
              <b-col  lg="6">
                  <b-input-group >
                      <b-input-group-prepend><label>Department</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.departemen" placeholder="Departmenet Name"></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col lg="6">
                  <b-input-group >
                      <b-input-group-prepend><label>Group/Category</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.golongan" ></b-form-input>
                  </b-input-group>
              </b-col>
            </b-row>            
            <b-row>
              <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Job Title</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.jabatan" placeholder="Job Title"></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Job Position</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.pangkat" placeholder="Position Name"></b-form-input>
                    </b-input-group>
                </b-col>
            </b-row>            
        </b-col>
        <b-col lg="5">
            <b-input-group >
              <b-input-group-prepend><label>Employee </label></b-input-group-prepend>
              <b-form-input v-model="tblData.crewname" placeholder="Name"></b-form-input>
              <b-form-input v-model="tblData.crewnik" placeholder="ID Number"></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Office/Field Worker</label></b-input-group-prepend>
                <b-form-select v-model="tblData.officer" :plain="true" :options="officerStatus"></b-form-select>
                <b-input-group-append><label class="pt-2">&nbsp; Active &nbsp;</label></b-input-group-append>
                <b-form-select v-model="tblData.terminate" :plain="true" :options="activeStatus"></b-form-select>
            </b-input-group>
            <b-row>
              <b-col lg="6"> &nbsp;
                </b-col>
                <b-col lg="6">
                  <b-row>
                    <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                    <b-button class="btn btn-secondary" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
                  </b-row>
                </b-col>
            </b-row>            
        </b-col>        
      </b-row>                      
          <b-table
            class="mb-0"
            ref="tblEmployee"
            responsive
            striped hover 
            style="font-size:smaller;" 
            :items="data"
            :fields="fields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            :key="tblData.limit" 
            @row-clicked="selectEmployee"
          >
          <template v-slot:cell(joinDate)="data">
            <span v-if="(data.item.joinDate)">{{ data.item.joinDate | moment("DD-MMM-YY") }}</span>
          </template>
          <template v-slot:cell(crewdob)="data">
            <span v-if="(data.item.crewdob)">{{ data.item.crewdob | moment("DD-MMM-YY") }}</span>
          </template>
          <template v-slot:cell(staffTetap)="data">
            <span v-if="(data.item.staffTetap==1)">Tetap</span>
            <span v-else>PKWT</span>
          </template>
          <template v-slot:cell(action)="data">
            <div class="text-center">
            <a href="javascript:void(0)" @click="edit(data.crew)">
              <i class="fa fa-pencil"></i>
            </a>
            |
            <a href="javascript:void(0)" class="text-danger" @click="deleteConfirm(data.crew)">
              <i class="fa fa-trash"></i>
            </a>
            </div>
          </template>

          </b-table>
          <b-row>
            <b-col cols="5">
              <div>
                Showing {{(tblData.page - 1) * tblData.limit + 1}}
                to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
                of {{tblData.total}} entries
              </div>
            </b-col>
            <b-col cols="2" >
              <b-input-group>
                  <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
                  <b-form-select :options="[10, 15, 20, 25, 30, 35, 40, 45, 50]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
              </b-input-group>
            </b-col>        
            <b-col cols="5">            
              <b-pagination
                align="right"
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
            </b-col>
          </b-row>
        <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
          <p class="mb-1">1 record is about to be permanently deleted</p>
          <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
        </b-modal>
    </b-card>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<script>
// import fs from "fs";
import crew from "../../apis/crew";
import Loading from 'vue-loading-overlay';
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      fields: [
          { key: "crewnik" , 
            label: "Employee ID",
            thStyle: "width:100px",
            sortable: true
          },
          { key: "crewname" , 
            label: "Employee Name",
            thStyle: "width:250px",
            sortable: true
          },
          {
            key: "jabatan",
            label: "Job Title",
            thStyle: "width:150px",
          },
          {
            key: "pangkat",
            label: "Position",
            thStyle: "width:150px",
            sortable: true
          },
          {
            key: "departemen",
            label: "Department",
            thStyle: "width:150px",
            sortable: true
          },
          {
            key: "golongan",
            label: "Group/Category",
            thStyle: "width:150px",
            sortable: true
          },
          {
            key: "crewhp",
            thStyle: "width:120px",
            label: "Mobile Number"
          },
          {
            key: "managerinfo",
            thStyle: "width:150px",
            label: "Report to",
            sortable: true
          },
          {
            key: "joinDate",
            thStyle: "width:90px",
            label: "Join Date",
            sortable: true
          },
          {
            key: "crewdob",
            thStyle: "width:90px",
            label: "Date of Birth",
            sortable: true
          },
          {
            key: "statuskawin",
            thStyle: "width:90px",
            label: "Married",
            sortable: true
          },
          {
            key: "npwp",
            thStyle: "width:150px",
            label: "NPWP"
          },
      ],
      tblData: {
        page: 1,
        limit: 10,
        total: 0,
        sortBy: null,
        sortDesc: false, terminate:'0'
      },
      model:{},
      crewImg:[{imgDataUrl:'', imgKey:'0'},{imgDataUrl:'', imgKey:'1'},{imgDataUrl:'', imgKey:'2'},{imgDataUrl:'', imgKey:'3'}],
      imgParams:{name:'gambar'},
      imgHeaders:{},
      imgDataUrl: '',
      imgUploadUrl: '',
      img3:'',
      imgIndex:0,
      horizontal: true,
      isLoading:false,
      showDelConfirm: false,
      showFilter:false,
      showImgTool:false,
      showList:true,
      showReport:false,
      reportUrl: null,
        activeStatus : [{ value: '', text: '-- ALL --' },, { value: '0', text: 'Yes' },{ value: '1', text: 'No' }],
        officerStatus : [{ value: '', text: '-- ALL --' },, { value: '0', text: 'Filed Worker ' },{ value: '1', text: 'Office Worker' }],

    };
  },
  components :{Loading},
  methods: {
    onFiltered(filteredEmployees) {
      this.tblData.total = filteredEmployees.length;
    },
    data: async function(ctx) {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.crewlist) {
            this.tblData[key] = filter.crewlist[key];
            filtered=true;
        }
        if (filtered === true) {
          this.showFilter=filtered;
          delete filter.crewlist;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading = true;
      let list = await crew.list(this.tblData);
      this.lkuLoading = false;
      return list;  
    },
    selectEmployee(record,index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    refresh() {
      this.$refs.tblEmployee.refresh();
    },
    clearFilter(ctx) {
        this.tblData.crewcode = '';
        this.tblData.crewname =  '';
        this.tblData.departemen = '';
        this.tblData.golongan =  '';
        this.tblData.group = '';
        this.tblData.officer = '';
        this.tblData.terminate = '';
        this.refresh();
    },    
    add: function(data) {
          const filter = this.$store.state.filter;
          filter.crewlist=this.tblData;
          this.$store.commit("filter", filter);
          router.push({name :'advance.crewfrm'});
    },
    edit: function() {
        if (this.model) {
          const filter = this.$store.state.filter;
          filter.crewlist=this.tblData;
          this.$store.commit("filter", filter);
          router.push({name :'advance.crewfrm', params: { crewkey: this.model.crewkey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      await crew.remove(this.model);
      this.refresh();
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await crew.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message, 'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error), 'ERROR MESSAGE',10000);
            }
        }
    },
    apihrdcallconfirm:  function() {
        this.$bvModal.msgBoxConfirm('Get the latest Employee Data from HR Department ?')
          .then(value => {
            // console.log('msgBoxConfirm ',  value);
            if (value==true){
              this.apihrdcall()
            }
          })
          .catch(err => {
            console.log('msgBoxConfirm ', err);
          })      

    },
    apihrdcall: async function() {
            try {
                this.isLoading=true;    
                const response = await crew.apihrdcall();
                console.log(response);
                toastr.success('Get Employee Data from HR Department, done sucessfully');
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message, 'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error), 'ERROR MESSAGE',10000);
                }
            }
    },
        
    closeFrm(){
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
